import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';
import { GetApiKeysResponse } from '@hud/portal-dtos/api-keys.dtos';
import { PORTAL_BASE } from '../consts';

export const API_KEYS = 'APIKeys';

export default function useAPIKeys() {
  const { client, isReady } = useClient();
  return useQuery({
    queryKey: [API_KEYS],
    queryFn: async () => {
      const response = await client.get<GetApiKeysResponse>(
        `${PORTAL_BASE}/account/api-keys`,
      );
      return GetApiKeysResponse.parse(response.data);
    },
    enabled: isReady,
  });
}
